const transporterMaps = [
  { TSICode: "TSI-22001", SCRCode: "22001" },
  { TSICode: "TSI-22002.1", SCRCode: "22002" },
  { TSICode: "TSI-22002.2", SCRCode: "22002A" },
  { TSICode: "TSI-22004", SCRCode: "22004" },
  { TSICode: "TSI-22004", SCRCode: "22004A" },
  { TSICode: "TSI-22004", SCRCode: "22004B" },
  { TSICode: "TSI-22004", SCRCode: "22004C" },
  { TSICode: "TSI-22004", SCRCode: "22004D" },
  { TSICode: "TSI-22005", SCRCode: "22005" },
  { TSICode: "TSI-22005", SCRCode: "22005A" },
  { TSICode: "TSI-22006", SCRCode: "22006" },
  { TSICode: "TSI-22007", SCRCode: "22007" },
  { TSICode: "TSI-22007", SCRCode: "22007A" },
  { TSICode: "TSI-22007", SCRCode: "22007B" },
  { TSICode: "TSI-22007", SCRCode: "22007C" },
  { TSICode: "TSI-22007", SCRCode: "22007D" },
  { TSICode: "TSI-22007", SCRCode: "22007E" },
  { TSICode: "TSI-22007", SCRCode: "22007F" },
  { TSICode: "TSI-22008", SCRCode: "22008" },
  { TSICode: "TSI-22008", SCRCode: "22008A" },
  { TSICode: "TSI-22009", SCRCode: "22009" },
  { TSICode: "TSI-22010", SCRCode: "22010" },
  { TSICode: "TSI-22010", SCRCode: "22010A" },
  { TSICode: "TSI-22011", SCRCode: "22011" },
  { TSICode: "TSI-22011", SCRCode: "22011A" },
  { TSICode: "TSI-22012", SCRCode: "22012" },
  { TSICode: "TSI-22013", SCRCode: "22013" },
  { TSICode: "TSI-22014", SCRCode: "22014" },
  { TSICode: "TSI-22015", SCRCode: "22015" },
  { TSICode: "TSI-22016", SCRCode: "22016" },
  { TSICode: "TSI-22016", SCRCode: "22016A" },
  { TSICode: "TSI-22016", SCRCode: "22016B" },
  { TSICode: "TSI-22017.1", SCRCode: "22017" },
  { TSICode: "TSI-22017.2", SCRCode: "22017A" },
  { TSICode: "TSI-22018.1", SCRCode: "22018" },
  { TSICode: "TSI-22018.2", SCRCode: "22018A" },
  { TSICode: "TSI-22019", SCRCode: "22019" },
  { TSICode: "TSI-22019", SCRCode: "22019A" },
  { TSICode: "TSI-22020", SCRCode: "22020" },
  { TSICode: "TSI-22021", SCRCode: "22021" },
  { TSICode: "TSI-22022", SCRCode: "22022" },
  { TSICode: "TSI-22023", SCRCode: "22023" },
  { TSICode: "TSI-22023", SCRCode: "22023A" },
  { TSICode: "TSI-22024", SCRCode: "22024" },
  { TSICode: "TSI-22025", SCRCode: "22025" },
  { TSICode: "TSI-22026", SCRCode: "22026" },
  { TSICode: "TSI-22028", SCRCode: "22028" },
  { TSICode: "TSI-22028", SCRCode: "22028A" },
  { TSICode: "TSI-22029", SCRCode: "22029" },
  { TSICode: "TSI-22030", SCRCode: "22030" },
  { TSICode: "TSI-22030", SCRCode: "22030A" },
  { TSICode: "TSI-22031", SCRCode: "22031" },
  { TSICode: "TSI-22032", SCRCode: "22032" },
  { TSICode: "TSI-22032", SCRCode: "22032A" },
  { TSICode: "TSI-22032", SCRCode: "22032B" },
  { TSICode: "TSI-22032", SCRCode: "22032C" },
  { TSICode: "TSI-22032", SCRCode: "22032D" },
  { TSICode: "TSI-56011", SCRCode: "56001" },
  { TSICode: "TSI-56007", SCRCode: "56003" },
  { TSICode: "TSI-56001", SCRCode: "56005" },
  { TSICode: "TSI-56001", SCRCode: "56005A" },
  { TSICode: "TSI-56001", SCRCode: "56005B" },
  { TSICode: "TSI-56001", SCRCode: "56005C" },
  { TSICode: "TSI-56001", SCRCode: "56005D" },
  { TSICode: "TSI-56001", SCRCode: "56005E" },
  { TSICode: "TSI-56001", SCRCode: "56005F" },
  { TSICode: "TSI-56015.1", SCRCode: "56012" },
  { TSICode: "TSI-56015.1", SCRCode: "56012A" },
  { TSICode: "TSI-56015.1", SCRCode: "56012B" },
  { TSICode: "TSI-56015.1", SCRCode: "56012C" },
  { TSICode: "TSI-56015.2", SCRCode: "56012D" },
  { TSICode: "TSI-56015.2", SCRCode: "56012E" },
  { TSICode: "TSI-56015.2", SCRCode: "56012F" },
  { TSICode: "TSI-56013", SCRCode: "56025" },
  { TSICode: "TSI-56013", SCRCode: "56025A" },
  { TSICode: "TSI-56013", SCRCode: "56025B" },
  { TSICode: "TSI-56003", SCRCode: "56029" },
  { TSICode: "TSI-56016", SCRCode: "56041" },
  { TSICode: "TSI-56004", SCRCode: "56052" },
  { TSICode: "TSI-56012", SCRCode: "56054" },
  { TSICode: "TSI-56012", SCRCode: "56054A" },
  { TSICode: "TSI-56010", SCRCode: "56069" },
  { TSICode: "TSI-56017", SCRCode: "56104" },
  { TSICode: "TSI-56017", SCRCode: "56104A" },
  { TSICode: "TSI-56017", SCRCode: "56104B" },
  { TSICode: "TSI-56017", SCRCode: "56104C" },
  { TSICode: "TSI-56022", SCRCode: "56107" },
  { TSICode: "TSI-56022", SCRCode: "56107A" },
  { TSICode: "TSI-56022", SCRCode: "56107B" },
  { TSICode: "TSI-56002", SCRCode: "56120" },
  { TSICode: "TSI-56002", SCRCode: "56120A" },
  { TSICode: "TSI-56020", SCRCode: "56125" },
  { TSICode: "TSI-56014", SCRCode: "56127" },
  { TSICode: "TSI-56009", SCRCode: "56137" },
  { TSICode: "TSI-56009", SCRCode: "56137A" },
  { TSICode: "TSI-56006", SCRCode: "56138" },
  { TSICode: "TSI-56006", SCRCode: "56138A" },
  { TSICode: "TSI-56006", SCRCode: "56138B" },
  { TSICode: "TSI-56006", SCRCode: "56138C" },
  { TSICode: "TSI-56005", SCRCode: "56166" },
  { TSICode: "TSI-56019", SCRCode: "56167" },
  { TSICode: "TSI-56019", SCRCode: "56167A" },
  { TSICode: "TSI-56008", SCRCode: "56169" },
  { TSICode: "TSI-56008", SCRCode: "56169A" },
  { TSICode: "TSI-56008", SCRCode: "56169B" },
  { TSICode: "TSI-56008", SCRCode: "56169C" },
  { TSICode: "TSI-56008", SCRCode: "56169D" },
  { TSICode: "TSI-56018", SCRCode: "56190" },
  { TSICode: "TSI-56018", SCRCode: "56190A" },
  { TSICode: "TSI-56018", SCRCode: "56190B" },
  { TSICode: "TSI-56023", SCRCode: "56206" },
  { TSICode: "TSI-56023", SCRCode: "56206A" },
  { TSICode: "TSI-56023", SCRCode: "56206B" },
  { TSICode: "TSI-56021", SCRCode: "56209" },
  { TSICode: "TSI-35001", SCRCode: "TSI-35001" },
  { TSICode: "TSI-35001", SCRCode: "TSI-35001A" },
  { TSICode: "TSI-35001", SCRCode: "TSI-35001B" },
  { TSICode: "TSI-35001", SCRCode: "TSI-35001C" },
  { TSICode: "TSI-35001", SCRCode: "TSI-35001D" },
  { TSICode: "TSI-35001", SCRCode: "TSI-35001E" },
  { TSICode: "TSI-35002", SCRCode: "TSI-35002" },
  { TSICode: "TSI-35002", SCRCode: "TSI-35002A" },
  { TSICode: "TSI-35002", SCRCode: "TSI-35002B" },
  { TSICode: "TSI-35002", SCRCode: "TSI-35002C" },
  { TSICode: "TSI-35002", SCRCode: "TSI-35002D" },
  { TSICode: "TSI-35002", SCRCode: "TSI-35002E" },
  { TSICode: "TSI-35002", SCRCode: "TSI-35002F" },
  { TSICode: "TSI-35003", SCRCode: "TSI-35003" },
  { TSICode: "TSI-35003", SCRCode: "TSI-35003A" },
  { TSICode: "TSI-35003", SCRCode: "TSI-35003B" },
  { TSICode: "TSI-35004", SCRCode: "TSI-35004" },
  { TSICode: "TSI-35004", SCRCode: "TSI-35004A" },
  { TSICode: "TSI-35005", SCRCode: "TSI-35005" },
  { TSICode: "TSI-35005", SCRCode: "TSI-35005A" },
  { TSICode: "TSI-35005", SCRCode: "TSI-35005B" },
  { TSICode: "TSI-35006", SCRCode: "TSI-35006" },
  { TSICode: "TSI-35006", SCRCode: "TSI-35006A" },
  { TSICode: "TSI-35006", SCRCode: "TSI-35006B" },
  { TSICode: "TSI-35007", SCRCode: "TSI-35007" },
  { TSICode: "TSI-35008.1", SCRCode: "TSI-35008" },
  { TSICode: "TSI-35008.2", SCRCode: "TSI-35008A" },
  { TSICode: "TSI-35009", SCRCode: "TSI-35009" },
  { TSICode: "TSI-35014", SCRCode: "TSI-35014" },
  { TSICode: "TSI-35014", SCRCode: "TSI-35014A" },
  { TSICode: "TSI-35014", SCRCode: "TSI-35014B" },
  { TSICode: "TSI-35014", SCRCode: "TSI-35014C" },
  { TSICode: "TSI-35014", SCRCode: "TSI-35014D" },
  { TSICode: "TSI-35015", SCRCode: "TSI-35015" },
  { TSICode: "TSI-35015", SCRCode: "TSI-35015A" },
  { TSICode: "TSI-35016", SCRCode: "TSI-35016" },
  { TSICode: "TSI-35016", SCRCode: "TSI-35016A" },
  { TSICode: "TSI-35017.1", SCRCode: "TSI-35017" },
  { TSICode: "TSI-35017.2", SCRCode: "TSI-35017A" },
  { TSICode: "TSI-35019.1", SCRCode: "TSI-35019" },
  { TSICode: "TSI-35019.2", SCRCode: "TSI-35019A" },
  { TSICode: "TSI-35020", SCRCode: "TSI-35020" },
  { TSICode: "TSI-35020", SCRCode: "TSI-35020A" },
  { TSICode: "TSI-35020", SCRCode: "TSI-35020B" },
  { TSICode: "TSI-35020", SCRCode: "TSI-35020C" },
  { TSICode: "TSI-35020", SCRCode: "TSI-35020D" },
  { TSICode: "TSI-35023", SCRCode: "TSI-35023" },
  { TSICode: "TSI-35024", SCRCode: "TSI-35024" },
  { TSICode: "TSI-35024", SCRCode: "TSI-35024A" },
  { TSICode: "TSI-35027.1", SCRCode: "TSI-35027" },
  { TSICode: "TSI-35027.2", SCRCode: "TSI-35027A" },
  { TSICode: "TSI-35028", SCRCode: "TSI-35028" },
  { TSICode: "TSI-35029", SCRCode: "TSI-35029" },
  { TSICode: "TSI-35029", SCRCode: "TSI-35029A" },
  { TSICode: "TSI-35030", SCRCode: "TSI-35030" },
  { TSICode: "TSI-35030", SCRCode: "TSI-35030A" },
  { TSICode: "TSI-35031", SCRCode: "TSI-35031" },
  { TSICode: "TSI-35031", SCRCode: "TSI-35031A" },
  { TSICode: "TSI-35033", SCRCode: "TSI-35033" },
  { TSICode: "TSI-35033", SCRCode: "TSI-35033A" },
  { TSICode: "TSI-35035", SCRCode: "TSI-35035" },
  { TSICode: "TSI-35036", SCRCode: "TSI-35036" },
  { TSICode: "TSI-35037", SCRCode: "TSI-35037" },
  { TSICode: "TSI-35038", SCRCode: "TSI-35038" },
  { TSICode: "TSI-35038", SCRCode: "TSI-35038A" },
  { TSICode: "TSI-35038", SCRCode: "TSI-35038B" },
  { TSICode: "TSI-35038", SCRCode: "TSI-35038C" },
  { TSICode: "TSI-35040", SCRCode: "TSI-35040" },
  { TSICode: "TSI-35041.1", SCRCode: "TSI-35041" },
  { TSICode: "TSI-35041.2", SCRCode: "TSI-35041A" },
  { TSICode: "TSI-35042", SCRCode: "TSI-35042" },
  { TSICode: "TSI-35043", SCRCode: "TSI-35043" },
  { TSICode: "TSI-35043", SCRCode: "TSI-35043A" },
  { TSICode: "TSI-35044", SCRCode: "TSI-35044" },
  { TSICode: "TSI-35045", SCRCode: "TSI-35045" },
  { TSICode: "TSI-35045", SCRCode: "TSI-35045A" },
  { TSICode: "TSI-35046", SCRCode: "TSI-35046" },
  { TSICode: "TSI-35046", SCRCode: "TSI-35046A" },
  { TSICode: "TSI-35047", SCRCode: "TSI-35047" },
  { TSICode: "TSI-35048", SCRCode: "TSI-35048" },
  { TSICode: "TSI-35048", SCRCode: "TSI-35048A" },
  { TSICode: "TSI-35049", SCRCode: "TSI-35049" },
  { TSICode: "TSI-35049", SCRCode: "TSI-35049A" },
  { TSICode: "TSI-35051", SCRCode: "TSI-35051" },
  { TSICode: "TSI-35051.1", SCRCode: "TSI-35051A" },
  { TSICode: "TSI-35051.2", SCRCode: "TSI-35051B" },
  { TSICode: "TSI-35052", SCRCode: "TSI-35052" },
  { TSICode: "TSI-35053", SCRCode: "TSI-35053" },
  { TSICode: "TSI-35053", SCRCode: "TSI-35053A" },
  { TSICode: "TSI-35053", SCRCode: "TSI-35053B" },
  { TSICode: "TSI-35054.1", SCRCode: "TSI-35054" },
  { TSICode: "TSI-35054.2", SCRCode: "TSI-35054A" },
  { TSICode: "TSI-35056", SCRCode: "TSI-35056" },
  { TSICode: "TSI-35057", SCRCode: "TSI-35057" },
  { TSICode: "TSI-35057", SCRCode: "TSI-35057A" },
  { TSICode: "TSI-35057", SCRCode: "TSI-35057B" },
  { TSICode: "TSI-35059", SCRCode: "TSI-35059" },
  { TSICode: "TSI-35060", SCRCode: "TSI-35060" },
  { TSICode: "TSI-35060", SCRCode: "TSI-35060A" },
];

export function getTransporterTSICode(originalCode: string): string {
  const scrMatch = transporterMaps.find((c) => c.SCRCode === originalCode);
  if (scrMatch) {
    return scrMatch.TSICode;
  }
  return originalCode;
}
